import { Button } from "components/buttons";
import PropTypes from "prop-types";
import React, { useMemo } from "react";

export function DefectCaptureHasDefectsPreview(props) {
  const value = useMemo(() => {
    return props.answer;
  }, [props.answer]);

  const handleChange = (newValue) => {
    props.onChange(newValue);
  };

  return <div className="check-preview-form-field">
    <Button
      onClick={() => handleChange(true)}
      text={"Yes"}
      className={`yesNo-selector ${value === true ? 'active' : ''}`}
    />
    <Button
      onClick={() => handleChange(false)}
      text={"No"}
      className={`yesNo-selector ${value === false ? 'active' : ''}`}
    />
  </div>
}

DefectCaptureHasDefectsPreview.propTypes = {
  answer: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};